import React, { useEffect } from 'react'
import { Button, Col, Layout, Row, Space, Switch } from 'antd'
import { MenuUnfoldOutlined, MenuFoldOutlined } from '@ant-design/icons'
import { observer } from 'mobx-react-lite'
import PropTypes from 'prop-types'
import { CommentOutlined } from '@ant-design/icons'
import { runInAction } from 'mobx'
import { v4 as uuidv4 } from 'uuid'

import '../../../design/App.css' // TODO: Integrate in scss

import NavBar from './NavBar'
import RequestModal from '../../../pages/platform/Requests/RequestModal'
import { newRequest } from '../../../stores/requests/actions'

import { headerStyle } from '../../../design/app-style-config'
import { useStores } from '../../../cls/stores/MobXProvider'
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { actLoadNotificationsCount } from '../../../stores/ui-lst-notification/actions'
import { requiredVersion } from '../../../config/versionUtils'
import { actLoadUserDashboardData } from '../../../stores/users/actions'
import {
	stripeLoadPlans,
	stripeLoadUserSubscriptions
} from '../../../stores/subscriptions/actions'

const { Header } = Layout

const MainHeader = observer(({ collapsed, setCollapsed }) => {
	const { users, appType, subscriptions, uiLstRequests } = useStores()
	const { appIsClient } = appType
	const { isLoggedIn, loggedInUserId, loggedInUser } = users
	const isSuperAdmin = loggedInUser.isSuperAdmin
	// ACTIVE FOR TEAM DEV ENVIRONMENT
	const switchAppTypePermission = isSuperAdmin //isSuperAdmin || appEnvironment === 'dev' //

	useEffect(() => {
		appIsClient &&
			isLoggedIn &&
			subscriptions.plans.length === 0 &&
			stripeLoadPlans()
		appIsClient && isLoggedIn && stripeLoadUserSubscriptions(loggedInUserId)
	}, [loggedInUserId])

	useEffect(() => {
		isLoggedIn &&
			requiredVersion('1.2.0') &&
			actLoadNotificationsCount().then(() =>
				console.warn(':: Notifications count loaded from header.js')
			)
		isLoggedIn && actLoadUserDashboardData()
	}, [loggedInUser])

	return (
		<Header style={headerStyle} id="app-header">
			<Row
				wrap={false}
				align="middle"
				justify="space-between"
				style={{ width: '100%' }}
			>
				<Col flex="none">
					<Button
						type="text"
						icon={
							collapsed ? (
								<MenuUnfoldOutlined />
							) : (
								<MenuFoldOutlined />
							)
						}
						onClick={() => setCollapsed(!collapsed)}
						style={{
							fontSize: '16px',
							width: 64,
							height: 64,
							color: '#000',
							marginLeft: -25
						}}
					/>
				</Col>
				<Col flex="auto">
					<Space
						wrap={false}
						direction="horizontal"
						align="center"
						style={{
							width: '100%',
							display: 'flex',
							justifyContent: 'flex-end'
						}}
					>
						{switchAppTypePermission && (
							<Switch
								value={appType.appIsClient}
								checkedChildren="Client"
								unCheckedChildren="Team"
								defaultChecked
								onChange={appType.toggleAppType}
							/>
						)}
						{users.isLoggedIn && (
							<>
								<RequestModal />
								<Button
									id="new-request-button"
									icon={<CommentOutlined />}
									// className="ant-btn-color-primary"
									style={{
										// position: 'fixed',
										// bottom: 30,
										// right: 30,
										// fontSize: 28,
										cursor: 'pointer',
										border: 'none',
										boxShadow: 'unset'

										// zIndex: 1000,
										// borderWidth: 1,
										// borderColor: 'rgb(0 0 0)',
										// borderStyle: 'dashed',
										// borderRadius: '50%'
										// padding: 10
									}}
									onClick={() => {
										const newId = uuidv4()
										newRequest(newId).then(() => {
											runInAction(() => {
												uiLstRequests.setModal(
													'request-modal',
													{
														visible: true,
														itmId: newId
													}
												)
											})
										})
									}}
								/>
							</>
						)}
						<NavBar />
					</Space>
				</Col>
			</Row>
		</Header>
	)
})

MainHeader.propTypes = {
	collapsed: PropTypes.bool,
	setCollapsed: PropTypes.func
}

export default MainHeader
